function rewriteUrl(url: URL, pathname: string): URL {
    const rewrittenUrl = new URL(url);

    rewrittenUrl.hash = '';
    rewrittenUrl.pathname = pathname;
    rewrittenUrl.search = '';

    return rewrittenUrl;
}

export function oldRoutesCompat(url: URL): URL | undefined {
    if (url.pathname !== '/' || !url.hash.startsWith('#/')) {
        return undefined;
    }

    const legacyUrl = new URL(url.hash.slice(1), url.origin);
    const parts = legacyUrl.pathname.split('/');

    // /#/pagamento/:id?$tipo
    if (parts[1] === 'pagamento' && parts[2]) {
        const rewrittenUrl = rewriteUrl(url, `/p/pagamento/${parts[2]}`);

        rewrittenUrl.search = legacyUrl.search;

        return rewrittenUrl;
    }

    // /#/compartilhamento/:id?$tipo$registrarVisualizacao
    if (parts[1] === 'compartilhamento' && parts[2]) {
        const rewrittenUrl = rewriteUrl(url, `/p/compartilhamento/${parts[2]}`);

        rewrittenUrl.search = legacyUrl.search;

        return rewrittenUrl;
    }

    // /#/impressao/public/:filetype
    if (parts[1] === 'impressao' && parts[2] === 'public' && parts[3]) {
        return rewriteUrl(url, `/p/impressao/${parts[3]}`);
    }

    const slug = parts[1];

    if (!slug) {
        return rewriteUrl(url, '/');
    }

    // /#/meuNegocio/cliente
    if (parts.length === 3 && parts[2] === 'cliente') {
        const rewrittenUrl = rewriteUrl(url, `/p/cliente/${slug}`);
        const documento = legacyUrl.searchParams.get('documento');

        if (documento) {
            rewrittenUrl.searchParams.set('documento', documento);
        }

        return rewrittenUrl;
    }

    // /#/meuNegocio/catalogo
    if (parts.length === 3 && parts[2] === 'catalogo') {
        return rewriteUrl(url, `/p/catalogo/${slug}`);
    }

    return rewriteUrl(url, '/');
}
